import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './footer.css';

const NAV_LINKS: Array<{ path: string; sectionId: string; label: string }> = [
  { path: '/about', sectionId: 'about', label: 'About' },
  { path: '/skills', sectionId: 'skills', label: 'Skills' },
  { path: '/experience', sectionId: 'experience', label: 'Experience' },
  { path: '/projects', sectionId: 'projects', label: 'Projects' },
  { path: '/blogs', sectionId: 'blogs', label: 'Blogs' },
  { path: '/contact', sectionId: 'contact', label: 'Contact' },
];

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string, sectionId?: string) => {
    e.preventDefault();
    if (pathname !== path) {
      navigate(path);
      return;
    }
    // Same route — scroll to section
    if (sectionId) {
      const target = document.getElementById(sectionId);
      if (target) {
        const headerEl = document.querySelector('.header') as HTMLElement | null;
        const headerHeight = headerEl ? headerEl.offsetHeight : 0;
        window.scrollTo({ top: target.offsetTop - headerHeight, behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__inner">
          <a href="/" className="footer__brand" onClick={(e) => handleNavClick(e, '/', 'home')}>
            <span className="footer__mark" aria-hidden="true">AA</span>
            <span className="footer__name">Adewale Adenle</span>
          </a>

          <ul className="footer__nav">
            {NAV_LINKS.map(({ path, sectionId, label }) => (
              <li key={path}>
                <a
                  href={path}
                  className="footer__link"
                  onClick={(e) => handleNavClick(e, path, sectionId)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>

          <div className="footer__bottom">
            <span className="footer__copy">
              © {new Date().getFullYear()} Adewale Adenle
            </span>

            <div className="footer__social">
              <a
                href="https://twitter.com/AdenleAdewale2"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
              >
                <i className="uil uil-twitter" />
              </a>
              <a
                href="https://www.linkedin.com/in/adewaleadenle/"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <i className="uil uil-linkedin" />
              </a>
              <a
                href="https://github.com/Adewale-1"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <i className="uil uil-github" />
              </a>
              <a
                href="mailto:waleadenle1@gmail.com"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="Email"
              >
                <i className="uil uil-envelope" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
